<!-- 货源审核 -->
<template>
  <div class="containerTable" style="padding:15px;">
    <vxe-toolbar
      id="toolbarId_or1"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button v-if="cargoaudit_search_button" @click="funcFilter">
          查询
        </el-button>
        <el-button
          v-if="getLimit('cargoaudit_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      show-footer
      highlight-hover-row
      row-id="id"
      :loading="loading"
      height="80%"
      :footer-method="footerMethod"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <!-- <vxe-table-column>
        <vxe-table-column field="branchCode" title="机构" :formatter="formatterBranch" min-width="150" sortable />
        <template v-slot:header>
          <el-select v-model="listQuery.branchCode" placeholder="请选择" clearable>
            <el-option v-for="item in branchList" :key="item.code" :label="item.groupName" :value="item.code" />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="请输入订单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="dfName"
          title="经办人"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.dfName"
            placeholder="请输入经办人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdByName"
          title="托运人名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentStaffTypeStr"
          title="托运人类型"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.shipmentStaffType"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in shipmentOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdByPhone"
          title="托运人电话"
          min-width="160"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByPhone"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="isMonthlyOrder"
          title="结算类型"
          min-width="100"
          :formatter="
            ({ cellValue }) => formatterField({ cellValue }, 'isMonthlyOrder')
          "
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.isMonthlyOrder"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in parentData.isMonthlyOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfShipment"
          title="装货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfShipment"
            placeholder="请输入装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="placeOfReceipt"
          title="收货地址"
          min-width="450"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.placeOfReceipt"
            placeholder="请输入收货地址"
            clearable
          />
        </template>
      </vxe-table-column>

      <vxe-table-column>
        <vxe-table-column
          field="status"
          :formatter="formatterStatus"
          title="订单状态"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select v-model="listQuery.status" clearable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalTypeName"
          title="货物名称"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入货物名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalName"
          title="运输要求"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalName"
            placeholder="请输入运输要求"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalPrice"
          title="货物单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="goodsTotal"
          title="货物总价(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.goodsTotalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.goodsTotalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="price"
          title="运费单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.priceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.priceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPrice"
          title="含税单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!--  <vxe-table-column
        v-if="
          this.partyType != 'SHIPMENT' && this.partyType != 'SHIPMENT_COMPANY'
        "
      >-->
      <vxe-table-column>
        <vxe-table-column
          field="realPrice"
          title="承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.realPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.realPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="allFee"
          title="运费总价(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.allFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.allFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxFee"
          title="含税总价(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPayFee"
          title="纳税金额"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPayFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPayFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxPrice"
          title="最高价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="maxTaxPrice"
          title="最高含税价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxTaxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxTaxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
        v-if="
          this.partyType != 'SHIPMENT' && this.partyType != 'SHIPMENT_COMPANY'
        "
      >-->
      <vxe-table-column>
        <vxe-table-column
          field="maxRealPrice"
          title="最高承运单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.maxRealPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.maxRealPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="distance"
          title="运输距离（公里）"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.distanceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.distanceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="货物数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastWeight"
          title="剩余数量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.lastWeightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.lastWeightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="coalNumber"
          title="需求车数(车)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.coalNumberStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.coalNumberEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="notReceivedCount"
          title="未接车数(车)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.notReceivedCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.notReceivedCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="receivedCount"
          title="已接车数(车)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.receivedCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.receivedCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="transferCount"
          title="已调单量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.transferCountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.transferCountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastLoadingTime"
          title="装车时间"
          min-width="420"
          sortable
        />
        <!--<template v-slot:header>
          <el-input v-model="listQuery.lastLoadingTime" placeholder="" clearable />
        </template>-->
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value1"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastLoadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="lastUnloadingTime"
          title="卸车时间"
          min-width="420"
          sortable
        />
        <!--<template v-slot:header>
          <el-input v-model="listQuery.lastUnloadingTime" placeholder="" clearable />
        </template>-->
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value2"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'lastUnloadingTime')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value3"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtModified"
          title="最后操作时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.value4"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtModified')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="modifiedByName"
          title="最后操作人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.modifiedByName"
            placeholder="请输入最后操作人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column title="操作" min-width="50" fixed="right">
          <template slot-scope="scope">
            <el-tooltip
              v-if="cargoaudit_audit_button"
              class="item"
              effect="dark"
              content="审核"
              placement="top"
              width="50"
            >
              <vxe-button type="text" @click="Toexamine(scope.row)">
                <i class="el-icon-thumb" />
              </vxe-button>
            </el-tooltip>
          </template>
        </vxe-table-column>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal v-model="price" title="价格调整" width="300" height="300" resize>
      <reject ref="Modifyprice" @event1="receive" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { SupplyManagement } from "@/api/orderform";
import { getLimit } from "@/utils/getLimit.js";
import reject from "./components/reviewReject.vue";
export default {
  components: {
    reject
  },
  data() {
    return {
      message: "",
      price: false,
      cargoaudit_search_button: false, //查询
      cargoaudit_audit_button: false, //审核
      tableData: [],
      parentData: {
        isMonthlyOrderOptions: []
      },
      sumObject: {},
      listQuery: {
        value1: "",
        value2: "",
        value3: "",
        value4: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        isModifyFinish: 0
      },
      // Pagingconf: [],
      toolbarButtons: [
        {
          code: "btn1",
          name: "查询"
        }
      ],
      options: [
        {
          value: "0",
          label: "未接单"
        },
        {
          value: "1",
          label: "已接单"
        },
        {
          value: "2",
          label: "已装货"
        },
        {
          value: "3",
          label: "已卸货"
        },
        {
          value: "4",
          label: "已结算"
        },
        {
          value: "5",
          label: "已完成"
        }
      ],
      shipmentOptions: [
        { label: "个体托运人", value: 0 },
        { label: "企业托运人", value: 1 }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList,
      exportObj: {
        exportUrl: "/ntocc-tms-api/order/exportCargoAudit", //导出接口
        name: "货源审核"
      }
    };
  },
  created() {
    this.findList();
    this.parentData.isMonthlyOrderOptions = [
      { label: "次结", value: 0 },
      { label: "月结", value: 1 }
    ];
    this.cargoaudit_search_button = getLimit("cargoaudit_search_button"); //查询
    this.cargoaudit_audit_button = getLimit("cargoaudit_audit_button"); //审核
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        SupplyManagement(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.tableData.forEach(item => {
            item.price = item.price + item.isTrunkName;
            item.realPrice = item.realPrice + item.isTrunkName;
            item.coalPrice = item.coalPrice + "元/" + item.coalUnitName;
            item.maxPrice = item.maxPrice + item.isTrunkName;
            item.maxTaxPrice = item.maxTaxPrice + item.isTrunkName;
            item.maxRealPrice = item.maxRealPrice + item.isTrunkName;
            item.weight = item.weight + item.coalUnitName;
            item.lastWeight = item.lastWeight + item.coalUnitName;
            item.taxPrice = item.taxPrice + "元/" + item.coalUnitName;
          });
          this.listQuery.total = response.data.total;
          this.sumObject = response.data.sumObject;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    receive() {
      this.price = false;
      this.findList();
    },
    Toexamine(row) {
      this.$refs.Modifyprice.modpic(row);
      this.price = true;
    },
    formatterField({ cellValue }, prefix) {
      const item = this.parentData[`${prefix}Options`].find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterStatus({ cellValue }) {
      switch (cellValue) {
        case 0:
          return "未接单";
        case 1:
          return "已接单";
        case 2:
          return "已装货";
        case 3:
          return "已卸货";
        case 4:
          return "已结算";
        case 5:
          return "已打款";

        default:
          break;
      }
    },
    // 合计
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (["coalNumber"].includes(column.property)) {
            return this.sumObject.coalNumber;
          }
          if (["weight"].includes(column.property)) {
            return (
              this.sumObject.ton +
              "吨//" +
              this.sumObject.cubicMeter +
              "方//" +
              this.sumObject.pieces +
              "件"
            );
          }
          // if (column.property === "invoiceAmount") {
          //   return "待定";
          // }
          if (["goodsTotal"].includes(column.property)) {
            return this.sumObject.goodsTotal;
          }
          if (["allFee"].includes(column.property)) {
            return this.sumObject.allFee;
          }
          if (["taxFee"].includes(column.property)) {
            return this.sumObject.taxFee;
          }
          if (["taxPayFee"].includes(column.property)) {
            return this.sumObject.taxPayFee;
          }
          if (["distance"].includes(column.property)) {
            return this.sumObject.distance;
          }
          if (["notReceivedCount"].includes(column.property)) {
            return this.sumObject.notReceivedCount;
          }
          if (["receivedCount"].includes(column.property)) {
            return this.sumObject.receivedCount;
          }
          if (["transferCount"].includes(column.property)) {
            return this.sumObject.transferCount;
          }
          return "-";
        })
      ];
    }
  }
};
</script>
